import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {SharedModule} from '../../../../../../shared/shared.module';
import {LoadingModule} from '../../../../../../components/loading/loading.module';
import {SimpleDialogModule} from '../../../../../../components/simple-dialog/simple-dialog.module';
import {FilePreviewModule} from '../../../../../file-preview/file-preview.module';
import {FileComponent} from './file.component';


@NgModule({
  imports: [
    MatButtonModule,
    SharedModule,
    LoadingModule,
    SimpleDialogModule,
    FilePreviewModule
  ],
  declarations: [
    FileComponent
  ],
  entryComponents: [
    FileComponent
  ],
  exports: [
    FileComponent
  ]
})

export class FileModule {}
